import OnboardingProvider, { useOnboardingContext } from './ui/OnboardingProvider';
import onboardingSegment from './models/state-manager/onboardingSegment';
import { ONBOARDING_STEPS_TYPES } from './constants/index';

export default OnboardingProvider;

export { useOnboardingContext, onboardingSegment, ONBOARDING_STEPS_TYPES };
